import { useGetActiveDriverQuery } from '@/pages/Business/pages/DriverMonitoring/services';
import { INDIVIDUAL_DRIVER_POLLING_INTERVAL } from '@/pages/Business/pages/DriverMonitoring/config/pollingConfig';
import { DriverGpsPosition } from '../models/DriverGpsPosition';

const STALE_SIGNAL_THRESHOLD_MS = 90000;

export interface UseDriverGpsPositionOptions {
  skip?: boolean;
  pollingInterval?: number;
}

export interface UseDriverGpsPositionResult {
  position: DriverGpsPosition | undefined;
  isLoading: boolean;
  error: unknown;
  isStale: boolean;
  hasSignal: boolean;
}

export const useDriverGpsPosition = (
  driverId: string | null | undefined,
  options: UseDriverGpsPositionOptions = {}
): UseDriverGpsPositionResult => {
  const {
    skip = false,
    pollingInterval = INDIVIDUAL_DRIVER_POLLING_INTERVAL,
  } = options;

  const { data, isLoading, error: queryError } = useGetActiveDriverQuery(
    driverId ?? '',
    {
      pollingInterval,
      skip: skip || !driverId,
    }
  );

  const position = data?.data;

  const lastUpdate = position?.updatedAt || position?.createdAt;
  const isStale = lastUpdate
    ? Date.now() - new Date(lastUpdate).getTime() > STALE_SIGNAL_THRESHOLD_MS
    : false;

  const hasSignal = Boolean(position) && !isStale;

  const isDriverNotFound =
    typeof queryError === 'object' &&
    queryError !== null &&
    'status' in queryError &&
    (queryError as { status: unknown }).status === 404;

  const error = isDriverNotFound ? undefined : queryError;

  return {
    position,
    isLoading,
    error,
    isStale,
    hasSignal,
  };
};
